import {APIService} from '@/services/api.service';

export async function removeTrip(tripId: string, userId: string) {
  return APIService.delete(`session`, {
    params: {
      user_id: userId,
      trip_id: tripId,
    },
  });
}
